var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceMouthClosedOutlineGradient = function SvgFaceMouthClosedOutlineGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5687 16.997C21.5687 16.629 21.27 16.3303 20.902 16.3303C20.534 16.3303 20.2353 16.629 20.2353 16.997C20.2353 19.2846 18.3353 21.146 15.9997 21.146C13.664 21.146 11.7637 19.2846 11.7637 16.997C11.7637 16.629 11.465 16.3303 11.097 16.3303C10.7287 16.3303 10.4303 16.629 10.4303 16.997C10.4303 20.02 12.9287 22.4793 15.9997 22.4793C19.0703 22.4793 21.5687 20.02 21.5687 16.997ZM19.4183 10.187C18.8547 10.187 18.3977 10.8853 18.3977 11.7466C18.3977 12.608 18.8547 13.306 19.4183 13.306C19.9817 13.306 20.4387 12.608 20.4387 11.7466C20.4387 10.8853 19.9817 10.187 19.4183 10.187ZM12.5687 10.187C12.005 10.187 11.548 10.8853 11.548 11.7466C11.548 12.608 12.005 13.306 12.5687 13.306C13.1323 13.306 13.5893 12.608 13.5893 11.7466C13.5893 10.8853 13.1323 10.187 12.5687 10.187ZM15.9997 4.16665C9.47467 4.16665 4.16634 9.47498 4.16634 16C4.16634 22.5246 9.47467 27.833 15.9997 27.833C22.5247 27.833 27.833 22.5246 27.833 16C27.833 9.47498 22.5247 4.16665 15.9997 4.16665ZM15.9997 29.1663C8.73967 29.1663 2.83301 23.26 2.83301 16C2.83301 8.73998 8.73967 2.83331 15.9997 2.83331C23.2597 2.83331 29.1663 8.73998 29.1663 16C29.1663 23.26 23.2597 29.1663 15.9997 29.1663Z",
    fill: "url(#mouth_gradient)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mouth_gradient",
    x1: 2.83301,
    y1: 2.83331,
    x2: 29.166,
    y2: 29.1666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75B2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B275F0"
  })))));
};
export default SvgFaceMouthClosedOutlineGradient;